import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectablePill } from './SelectablePill';
import { CHANNEL_OTHER_ID, CHANNELS } from './onboardingOptions';
import { useGettingStartedOnboarding } from './useGettingStartedOnboarding';
import { Input } from '@/Domain/components/Shared/Input/Input';

export const DeploymentStep = () => {
  const { t } = useTranslation('getting_started');
  const {
    deploymentSelection,
    toggleDeploymentChannel,
    deploymentOtherText,
    setDeploymentOtherText,
  } = useGettingStartedOnboarding();
  const otherSelected = deploymentSelection.has(CHANNEL_OTHER_ID);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-2" data-testid="gs-deployment-pills">
        {CHANNELS.map((channel) => (
          <SelectablePill
            key={channel.id}
            label={channel.label}
            icon={channel.icon}
            iconColor={channel.iconColor}
            selected={deploymentSelection.has(channel.id)}
            onToggle={() => toggleDeploymentChannel(channel.id)}
            testId={`gs-deployment-pill-${channel.id}`}
          />
        ))}
      </div>
      {otherSelected && (
        <Input
          type="text"
          value={deploymentOtherText}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setDeploymentOtherText(e.target.value)}
          placeholder={t('deployment_step.other_placeholder')}
          maxLength={200}
          autoComplete="off"
          data-testid="gs-deployment-other-input"
        />
      )}
    </div>
  );
};
